// src/App.js
import React, { useEffect } from 'react';
import FormularioJSON from '../../../components/FormularioJSON';
import dadosMenu from '../../../../lib/json/menu.json';
import { useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import empresasData from '../../../../lib/json/empresas.json'
import SelectFixo from '../../../components/SelectFixo';
import { LabelTabContainer } from './styles';
import InputGeral from '../../../components/InputGeral/Index';
import ConfiguracaoEmpresa from '../../../components/ConfigEmpresa';
import { useNavigate, useParams } from 'react-router-dom';
import { MapeamentoMenu, MapeamentoPermissao, MenuHabilitadoJSON, PermissoesEmpresasJSON, SucessoMsg } from '../../../contents/VariaveisGlobais';
import SubmitForm from '../../../components/SubmitForm';
import { ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../../backend/ConsumoAPI';
import TitlePage from '../../../components/TitlePage';
import axios from 'axios';

function FichaPerfilUsuario(){
	const navigate = useNavigate();
	const { idPerfilUsuario } = useParams();
	const [dadosPerfil, setDadosPerfil] = useState();
	
	const empresasDisponiveis = empresasData.empresas.filter((empresa) => empresa.habilitado);

	const options = empresasDisponiveis.map((empresa) => ({
		value: empresa.empresaFilial + ' - ' + empresa.nomeEmpresa,
		text: empresa.nomeEmpresa,
		index: empresa.empresaFilial
	}));

	const [selecaoMenu, setSelecaoMenu] = useState({});
	const [empresas, setEmpresas] = useState();
	const [empresaHabilitadasSelect, setEmpresaHabilitadasSelect] = useState();
	const [selectedValues, setSelectedValues] = useState({values: {}});
	const [empresasConfig, setEmpresasConfig] = useState({});
	const [descricao, setDescricao] = useState();

	useEffect(() => {
		if (dadosPerfil){
			if (idPerfilUsuario){
				var perfilAlteracao 		= dadosPerfil.perfil.find( (item) => item.idPerfil === parseInt(idPerfilUsuario))
				var empresaHabilitadas	    = options && (options.filter(objeto => perfilAlteracao.empresaHabilitadas.includes(objeto.index)).map((item) => item.value));
				var empresaHabilitadasSelect = options && (options.filter(objeto => perfilAlteracao.empresaHabilitadas.includes(objeto.index)) );
				var centroCustoConfig = {};
				JSON.parse(perfilAlteracao.parametrosEmpresas).forEach(item => {const { empresaFilial, centroCustoSelect } = item; if (centroCustoSelect && centroCustoSelect.length > 0) {centroCustoConfig[empresaFilial] = centroCustoSelect;}})
				
				setEmpresasConfig(PermissoesEmpresasJSON(JSON.parse(perfilAlteracao.parametrosEmpresas)))
				setSelecaoMenu(MenuHabilitadoJSON(JSON.parse(perfilAlteracao.menu)));
				setDescricao(perfilAlteracao.perfil)
				setEmpresas(empresaHabilitadas)
				setEmpresaHabilitadasSelect(empresaHabilitadasSelect)
				setSelectedValues({values: centroCustoConfig})
			}else{
				const empresasHabil = empresasDisponiveis.map((empresa) => empresa.empresaFilial + ' - ' + empresa.nomeEmpresa);
				setEmpresas(empresasHabil)
				setEmpresaHabilitadasSelect(options)
			}
		}
    }, [dadosPerfil]);

	useEffect(() => {
		const fetchData = async () => {
			var data = {perfil: []}
			try {
				// Construct the public URL for the JSON file
				const jsonUrl = `/lib/perfilUsuario.json`;
				
				const response = await axios.get(jsonUrl, {
					headers: {
						'Cache-Control': 'no-cache, no-store, must-revalidate',
						'Pragma': 'no-cache',
						'Expires': '0',
					},
				});
				
				const data = await response.data;
				
				// Set the data in the component's state
				await setDadosPerfil(data);
			} catch (error) {
				console.error('Error fetching JSON:', error);
			}

			return data
		};

		fetchData();
	}, []);

	const handleCancel = () => {
		navigate('/configuracoes/PerfilUsuario');
	}
	
	const handleSave = () => {
		const Menu = MapeamentoMenu(selecaoMenu, dadosMenu)
		const perfilEmpresa = MapeamentoPermissao(empresasConfig, selectedValues, empresas)

		//Gera o Menu de Acesso
		const novoArquivoJson = JSON.stringify(Menu, null, 2);
		const perfilEmpresaJSON = JSON.stringify(perfilEmpresa, null, 2);
		
		const jsonPerfil = {
			idPerfil: (idPerfilUsuario) ? parseInt(idPerfilUsuario) : dadosPerfil.perfil.length + 1,
			perfil: descricao,
			menu: novoArquivoJson,
			empresaHabilitadas: empresas.map( (item) => { return item.split('-')[0].trim() } ),
			parametrosEmpresas: perfilEmpresaJSON,
		}

		salvarArquivoPerfil(jsonPerfil);
	};
	
	const salvarArquivoPerfil = async (perfilSave) => {
		try {
			const response = await ( idPerfilUsuario ?
							ConsumoAPI_PUT('perfilSistema', perfilSave) :
							ConsumoAPI_POST('perfilSistema', perfilSave) );
			
			if (response.error == "00"){
				SucessoMsg(response.description);
				handleCancel();
			}
		} catch (error) {
			console.error('Error saving JSON file', error);
		}
	};

	const handleCheckboxChange = (item, isChecked, itemSelect) => {
		setSelecaoMenu((prevSelecoes) => ({
			...prevSelecoes,
			[itemSelect]: isChecked,
		}));
	};

	const handleChangeEmpresas = (selectedOption) =>{
		setEmpresas(selectedOption.map((item) => {return item.value} ));
		setEmpresaHabilitadasSelect(selectedOption)
	}

	const handleParametrosEmpresas = (item, isChecked, itemSelect) => {
		setEmpresasConfig((prevSelecoes) => ({
			...prevSelecoes,
			[itemSelect]: isChecked,
		}));
	};

	const handleSelectionChange = (values) => {
		setSelectedValues((centroCusto) => ({
			...centroCusto,
			values,
		}));
	};

	return (
		<>
			<Row>
				<Col md="12" xs="12">
					<TitlePage 
						text="Perfil de Usuário"
					/>
				</Col>
				<Col md="6" xs="12">
					<InputGeral 
						label="Perfil" 
						tipo='text' 
						value={descricao} 
						onChange={(e) => setDescricao(e.target.value)}
					/>
				</Col>
				<Col md="12" xs="12">
					<SelectFixo 
						multiple={true} 
						options={options} 
						value={empresas} 
						selectedOptionValue={empresaHabilitadasSelect} 
						isLabel={true} 
						label="Empresas" 
						onChange={handleChangeEmpresas}
					/>
				</Col>
				<Col md="12" xs="12">
					<Form.Group 
						
					>
						<LabelTabContainer 
							id="inputGroup-sizing-sm" 
							className="input-group-text"
						>
							Menu de Usuário
						</LabelTabContainer>

						<Form.Label 
							id="inputGroup-sizing-sm" 
							className="input-group-text"
						>
							<FormularioJSON 
								dados={dadosMenu} 
								onChecked={handleCheckboxChange} 
								selecoes={selecaoMenu}
							/>
						</Form.Label>
					</Form.Group>
				</Col>
			</Row>
			
			{ empresas && 
				(
					<Row>
						<Col md="12" xs="12">
							<Form.Group 
								
							>
								<LabelTabContainer 
									id="inputGroup-sizing-sm" 
									className="input-group-text"
								>
									Parâmetros por Empresa
								</LabelTabContainer>
								<Form.Label 
									id="inputGroup-sizing-sm" 
									className="input-group-text"
								>
									<ConfiguracaoEmpresa 
										empresas={empresas} 
										selecionados={empresasConfig} 
										centroCustoSelecionados={selectedValues.values} 
										preencheValue={handleParametrosEmpresas} 
										onSelectionChange={handleSelectionChange}
									/>
								</Form.Label>
							</Form.Group>
						</Col>
					</Row>
					
				)
			}
				
			<SubmitForm onSave={handleSave} onCancel={handleCancel}></SubmitForm>
		</>
	);
};

export default FichaPerfilUsuario;